import { RowUI as RowUIV1, ColUI as ColUIV1 } from "./Container/v1";
import { CardUI as CardUIV2 } from "./Card/v2";
import { withVersions } from "v2/hocs/withVersions";
import withCircle from "../hocs/withCircle";
import { Avatar } from "@mui/material";

const Card = {
  Badge: withVersions({
    v1: CardUIV2.Badge,
    v2: CardUIV2.Badge,
  }),
  Item: withVersions({
    v1: CardUIV2.Item,
    v2: CardUIV2.Item,
  }),
  Section: withVersions({
    v1: CardUIV2.Section,
    v2: CardUIV2.Section,
  }),
  ImageSection: withVersions({
    v1: CardUIV2.ImageSection,
    v2: CardUIV2.ImageSection,
  }),
};

const Row = withVersions({
  v1: RowUIV1,
  v2: RowUIV1,
});

const Col = withVersions({
  v1: ColUIV1,
  v2: ColUIV1,
});

const Circle = {
  Image: withVersions({
    v1: withCircle(Avatar),
    v2: withCircle(Avatar),
  }),
  Box: withVersions({
    v1: withCircle(Row),
    v2: withCircle(Row),
  }),
};

export { Card, Row, Col, Circle };
